import { actionTypes} from '../actions/cryptoMostWanted'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes)
